import { render, staticRenderFns } from "./LicenseDialog.vue?vue&type=template&id=01cf1d8a&scoped=true"
import script from "./LicenseDialog.vue?vue&type=script&lang=js"
export * from "./LicenseDialog.vue?vue&type=script&lang=js"
import style0 from "./LicenseDialog.vue?vue&type=style&index=0&id=01cf1d8a&prod&scoped=true&lang=css"
import style1 from "./LicenseDialog.mobile.css?vue&type=style&index=1&id=01cf1d8a&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01cf1d8a",
  null
  
)

export default component.exports